/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2023] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import { View } from 'backbone.marionette';
import Syphon from 'backbone.syphon';

import { formatDisplayDate } from '@/util/MomentUtils';
import { validateForm } from '@/util/ParsleyUtils';

import tmplAssetFormView from './AssetFormView.hbs';

import './AssetFormView.css';

const AssetFormView = View.extend({
  template: tmplAssetFormView,

  ui: {
    assetForm: '.asset-form',
    assetChangeBtn: '.save-asset-changes',
    toggle: '.toggle',
    contractAwardDate: 'input[name="contractAwardDate"]',
    contractEndDate: 'input[name="contractEndDate"]',
    eqInstallDate: 'input[name="eqInstallDate"]',
    uninstallDate: 'input[name="uninstallDate"]'
  },

  events: {
    'click @ui.assetChangeBtn': 'onClickSaveAssetChanges',
    'click @ui.toggle': 'onClickToggle'
  },

  onBeforeRender() {
    this.model.set(
      'formattedSellingPrice',
      parseInt(this.model.get('sellingPrice')).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD'
      })
    );

    this.model.set(
      'formattedOriginalValue',
      parseInt(this.model.get('originalValue')).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD'
      })
    );
  },

  onRender() {
    this.ui.contractAwardDate.datepicker({ format: 'mm/dd/yyyy' });
    if (this.model.get('contractAwardDate')) {
      this.ui.contractAwardDate.datepicker('setDate', formatDisplayDate(this.model.get('contractAwardDate')));
    }

    this.ui.contractEndDate.datepicker({ format: 'mm/dd/yyyy' });
    if (this.model.get('contractEndDate')) {
      this.ui.contractEndDate.datepicker('setDate', formatDisplayDate(this.model.get('contractEndDate')));
    }

    this.ui.eqInstallDate.datepicker({ format: 'mm/dd/yyyy' });
    if (this.model.get('eqInstallDate')) {
      this.ui.eqInstallDate.datepicker('setDate', formatDisplayDate(this.model.get('eqInstallDate')));
    }

    this.ui.uninstallDate.datepicker({ format: 'mm/dd/yyyy' });
    if (this.model.get('uninstallDate')) {
      this.ui.uninstallDate.datepicker('setDate', formatDisplayDate(this.model.get('uninstallDate')));
    }
  },

  async onClickSaveAssetChanges(e) {
    e.preventDefault();
    await validateForm(this.ui.assetForm);
    const formData = Syphon.serialize(this);
    formData.rowIndex = this.model.get('rowIndex');
    if (formData.asset !== this.model.get('asset')) formData.formerAssetId = this.model.get('asset');
    this.triggerMethod('update:asset', formData);
  },

  onClickToggle() {
    const asset = this.model.get('asset').concat('-caret');
    const caret = document.getElementById(asset);
    if (caret.classList.contains('fa-caret-down')) {
      caret.classList.remove('fa-caret-down');
      caret.classList.add('fa-caret-up');
    } else if (caret.classList.contains('fa-caret-up')) {
      caret.classList.remove('fa-caret-up');
      caret.classList.add('fa-caret-down');
    }
  }
});

export default AssetFormView;
